import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';

const tags = {
  getSystemLogs: 'getSystemLogs',
};

export const systemLogsApi = createApi({
  reducerPath: 'systemLogsApi',
  tagTypes: [tags.getSystemLogs],
  endpoints: (builder) => ({
    getSystemLogs: builder.query({
      query: ({ log_date, hour }) => {
        const params = {
          log_date,
          hour,
        };

        const queryString = serialize(params);
        return { url: `/logger/logs?${queryString}`, method: 'GET' };
      },
      providesTags: [tags.getSystemLogs],
    }),
  }),
});

export const {
  useGetSystemLogsQuery,
} = systemLogsApi;

const initialState = {
  selectedDate: new Date().toISOString().split('T')[0],
  selectedHour: new Date().getHours(),
  selectedMinute: null, // null означает показать все минуты
};

export const systemLogsParamsSlice = createSlice({
  name: 'systemLogsParams',
  initialState,
  reducers: {
    setDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setHour: (state, action) => {
      state.selectedHour = action.payload;
    },
    setMinute: (state, action) => {
      state.selectedMinute = action.payload;
    },
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetParams: () => initialState,
  },
});

export const { setDate, setHour, setMinute, setParams, resetParams } = systemLogsParamsSlice.actions;
export const systemLogsParamsReducer = systemLogsParamsSlice.reducer;
export const systemLogsParamsSelector = (state) => state.systemLogsParams;